import tippy from 'tippy.js/headless';

class BrixHotspot {
  static init(...parameters) {
    return new BrixHotspot(...parameters);
  }

  constructor(block) {
    if (block) {
      this.container = document.querySelector(`#${block.id} > .content`);
      this.tippy = null;
      this.hasBeenDisplayed = false;
      this.setupProductTooltip();
      this.setupListener();
    }
  }

  setupListener() {
    this.checkVisibility();
    this.listener = window.addEventListener('scroll', () => this.checkVisibility());
  }

  checkVisibility() {
    const { top, bottom, height } = this.container.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const offset = height * 0.2;
    if (height > viewportHeight) {
      if ((bottom - offset) > 0 && (bottom - offset) <= viewportHeight) {
        this.displayFirstTooltip();
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if ((bottom - offset) > 0 && (bottom - offset) <= viewportHeight && top >= 0) {
        this.displayFirstTooltip();
      }
    }
  }

  displayFirstTooltip() {
    if (this.hasBeenDisplayed) return;
    const hotspots = this.container.querySelectorAll('.hotspot-wrapper');

    [...hotspots].forEach((hotspot, i) => {
      if (i === 0) {
        // eslint-disable-next-line no-underscore-dangle
        this.tippy = hotspot._tippy;
        this.tippy.show();
        this.hasBeenDisplayed = true;
      }
    });
  }

  setupProductTooltip() {
    const hotspots = this.container.querySelectorAll('.hotspot-wrapper');

    [...hotspots].forEach((hotspot) => {
      const productInfo = hotspot.querySelector('.product-info');
      tippy(hotspot, {
        content: productInfo,
        offset: [-23, 10],
        allowHTML: true,
        trigger: 'click',
        appendTo: hotspot,
        interactive: 'true',
        placement: 'right-start',
        onShow() {
          requestAnimationFrame(() => {
            productInfo.classList.add('-animate');
          });
        },
        onHidden() {
          setTimeout(() => {
            productInfo.classList.remove('-animate');
          }, 200);
        },
        popperOptions: {
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                padding: 0,
              },
            },
            {
              name: 'flip',
              options: {
                fallbackPlacements: ['bottom', 'top', 'right', 'left'],
              },
            },
            {
              name: 'eventListeners',
              options: {
                scroll: false,
              },
            },
          ],
        },
        plugins: [{
          name: 'hideOnPopperBlur',
          defaultValue: true,
          fn(instance) {
            return {
              onCreate() {
                instance.popper.addEventListener('focusout', (event) => {
                  if (
                    instance.props.hideOnPopperBlur
                        && event.relatedTarget
                        && !instance.popper.contains(event.relatedTarget)
                  ) {
                    instance.hide();
                  }
                });
              },
            };
          },
        }],
        render(instance) {
          const popper = document.createElement('div');
          popper.appendChild(instance.props.content);
          return { popper };
        },
      });
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-hotspot', BrixHotspot.init);
}
